var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { hexToRgba } from '../helpers';
import { overlayEnter, overlayExit } from './keyframes';
export function overlayStyle(_a) {
    var isVisible = _a.isVisible;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    // Animation\n    opacity: 0;\n    animation: ", " 200ms ease-out\n      forwards;\n    z-index: ", ";\n  "], ["\n    background-color: ", ";\n    // Animation\n    opacity: 0;\n    animation: ", " 200ms ease-out\n      forwards;\n    z-index: ", ";\n  "])), hexToRgba(tokens.colors.navy, 0.7), isVisible ? overlayEnter() : overlayExit(), tokens.zIndex.overlay);
}
var templateObject_1;
